<template>
    <div class="home-root">
        <!-- <banner></banner> -->
        <workDynamics></workDynamics>
        <informationAndWork></informationAndWork>
        <noticeC></noticeC>
        <purchase></purchase>
        <linkList></linkList>
    </div>
</template>

<script>
import banner from "../banner.vue";
import workDynamics from "../workDynamics.vue";
import applicationCenter from "../applicationCenter.vue";
import noticeC from "../notice.vue";
import purchase from "../purchase.vue";
import linkList  from "../link-list.vue"
import informationAndWork from "../informationAndWork.vue";

export default {
    components: {
        banner,
        workDynamics,
        applicationCenter,
        noticeC,
        informationAndWork,
        purchase,
        linkList
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/PageAll/homePage.vue